import { Route, Switch } from "react-router-dom";
import DeliveryLeadershipPages from "../Tracks/DeliveryLeadership/App";

const DeliveryLeadership = () => {
  return (
    <>
      <DeliveryLeadershipPages />
    </>
  );
};

export default DeliveryLeadership;
